import api from '.';

import { buildQueryWithParams, makeListTags } from '../../Utils/api';

const tagType = 'session';

const sessionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    requestSessionsForCP: builder.query({
      query: ({ chargePointId = null, filter = {} }) => ({
        url: `/charge-points/${chargePointId}/sessions`,
        params: { filter }
      }),
      transformResponse: (res) => ({
        // list: res?.sessions?.results.reverse()
        list: res
      }),
      providesTags: makeListTags(tagType),
      keepUnusedDataFor: 0
    }),
    updateSession: builder.mutation({
      // params are: { id, label, transactionId, chargerId }
      query: ({ where, userId, data }) => ({
        url: `users/${userId}/sessions?where=${JSON.stringify(where)}`,
        method: 'PATCH',
        body: data,
      })
    }),
    startPaidSession: builder.mutation({
      query: (body) => ({
        url: '/sessions/start/paid',
        method: 'POST',
        body
      }),
      transformResponse: (res) => {
        return { sessionUrl: res.sessionUrl };
      }
    }),
    getSession: builder.query({
      query: ({ filter }) => ({
        url: `/sessions`,
        method: 'GET',
        params: { filter }
      }),
      transformResponse: (res) => {
        return res[0];
      }
    }),
    updatAllSession: builder.mutation({
      query: (body) => ({
        url: '/sessions',
        method: 'PATCH',
        body
      })
    }),
    getSessionBySecureId: builder.query({
      query: ({ secureId, filter }) => ({
        url: `/session/${secureId}`,
        method: 'GET',
        params: filter ? { filter } : undefined
      }),
      providesTags: ['Sessions']
    })
  })
});
export default sessionsApi;
export const {
  useRequestSessionsForCPQuery,
  useGetSessionQuery,
  useStartPaidSessionMutation,
  useUpdateSessionMutation,
  useGetSessionBySecureIdQuery
} = sessionsApi;
